import { render, staticRenderFns } from "./LandingLottieAnimation.vue?vue&type=template&id=36df521e&scoped=true"
import script from "./LandingLottieAnimation.vue?vue&type=script&lang=js"
export * from "./LandingLottieAnimation.vue?vue&type=script&lang=js"
import style0 from "./LandingLottieAnimation.vue?vue&type=style&index=0&id=36df521e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df521e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36df521e')) {
      api.createRecord('36df521e', component.options)
    } else {
      api.reload('36df521e', component.options)
    }
    module.hot.accept("./LandingLottieAnimation.vue?vue&type=template&id=36df521e&scoped=true", function () {
      api.rerender('36df521e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingLottieAnimation.vue"
export default component.exports